import _ from 'lodash';
import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {ApplicationComposerToolbarEntryPointModel} from '../../../../../models/api/applicationEntryPointModel';
import {AppState} from '../../../../../store/appState';
import {getApplications} from '../../../../../store/data/applications/applicationsSelectors';
import {ApplicationPanelLocationsEnum} from '../../../../../store/panels/applications/applicationPanelState';
import {getFlatPanels} from '../../../../../store/panels/panelsSelectors';
import {panelIsApplicationsPanel} from '../../../../../store/panels/panelsState';
import {ComposerPanelId, ViewerPanelId} from '../../../../../store/panels/panelStateBase';
import {ApplicationComposerEntryPointButton} from './applicationComposerEntryPointButton';

/*
 * Props.
 */

interface ApplicationComposerEntryPointButtonContainerProps {
  panelId: ComposerPanelId | ViewerPanelId;
  entryPoint: ApplicationComposerToolbarEntryPointModel;
}

/*
 * Selectors.
 */

function getEntryPoint(_state: AppState, props: ApplicationComposerEntryPointButtonContainerProps) {
  return props.entryPoint;
}

function getPanelId(_state: AppState, props: ApplicationComposerEntryPointButtonContainerProps) {
  return props.panelId;
}

const getEntryPointPanel = createSelector(
  [getEntryPoint, getFlatPanels, getPanelId],
  (entryPoint, panels, panelId) =>
    _(panels)
      .filter(panelIsApplicationsPanel)
      .filter(
        (p) =>
          p.location === ApplicationPanelLocationsEnum.POPOVER &&
          p.frame.frameId === entryPoint.frameId &&
          p.parentPanelId === panelId,
      )
      .first(),
);

const getApplication = createSelector([getApplications, getEntryPoint], (applications, entryPoint) => {
  const application = applications[entryPoint.applicationId];
  if (!application) {
    throw new Error('Could not find application for entry point');
  }
  return application;
});

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ApplicationComposerEntryPointButtonContainerProps>()(() => ({
  panel: getEntryPointPanel,
  application: getApplication,
}));

export const ApplicationComposerEntryPointButtonContainer = connect(mapStateToProps)(
  ApplicationComposerEntryPointButton,
);
